var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 118,
    viewBox: "0 0 117 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.2072,
    cy: 59.1246,
    r: 58.2072,
    fill: "#EA345F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_625_65051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 18,
    width: 82,
    height: 82
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.9446,
    y: 18.8621,
    width: 80.525,
    height: 80.525,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_625_65051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7702 70.7795L71.5646 60.9257C70.4758 59.7602 68.991 59.1245 67.5063 59.1245C65.9225 59.1245 64.5367 59.7602 63.4479 60.9257C62.3591 62.0912 61.7652 63.6805 61.7652 65.2698C61.7652 66.6472 62.1611 67.9187 62.854 68.9782H39.8896C36.7221 68.9782 34.0496 71.733 34.0496 75.2295C34.0496 78.6201 36.6232 81.4808 39.8896 81.4808H62.755C61.0723 83.9177 61.2702 87.3083 63.3489 89.5333C64.4377 90.6988 65.9225 91.3345 67.4073 91.3345C68.991 91.3345 70.3768 90.6988 71.4656 89.5333L80.6712 79.6796C81.76 78.5141 82.3539 77.0307 82.3539 75.3355C82.4529 73.5343 81.859 71.9449 80.7702 70.7795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6443 47.4696L44.8498 57.3233C45.9386 58.4888 47.4234 59.1245 48.9082 59.1245C50.4919 59.1245 51.8777 58.4888 52.9665 57.3233C54.0553 56.1578 54.6493 54.5685 54.6493 52.9792C54.6493 51.6018 54.2533 50.3303 53.5604 49.2708H76.5248C79.6923 49.2708 82.3649 46.516 82.3649 43.0195C82.3649 39.629 79.7913 36.7682 76.5248 36.7682H53.6594C55.3421 34.3313 55.1442 30.9407 53.0655 28.7157C51.9767 27.5502 50.4919 26.9145 49.0071 26.9145C47.4234 26.9145 46.0376 27.5502 44.9488 28.7157L35.7433 38.5694C34.6544 39.7349 34.0605 41.2183 34.0605 42.9135C33.9615 44.7148 34.5554 46.3041 35.6443 47.4696Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferMessage);
export default __webpack_public_path__ + "static/media/transferMessage.261ceae0cabb60b6610585a7fe3c3651.svg";
export { ForwardRef as ReactComponent };